import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { InputCheckbox } from '../../../../forms';
import { ControllerInputSelect, InputTextCleaner } from '../../../../forms/react-hook-form';
import { FormPassengerAddress, REGEXP_CITY } from './PassengerAddress.model';
import styles from './PassengerAddress.module.css';
import { FormDataApis, REGEXP_CLEAN, SelectOptions } from '../../ApisForm.model';
import { ApisFormContext, searchOption } from '../../ApisForm.utils';
import { PassengerAddressFields } from '../../ApisForm.constants';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';

export const PassengerAddress = () => {
	const { t } = useTranslation(['passenger-address', 'common']);
	const { register, setValue } = useFormContext<FormDataApis>();
	const { listOptions, isFormDisabled = false, passengerAddress, isMultiPassengers } = useContext(ApisFormContext);
	//const destination = isPrivacyStatement ? 'USA' : '';

	useEffect(() => {
		if (passengerAddress) {
			const updateData: FormPassengerAddress = {
				address: passengerAddress.address.value,
				zipCode: passengerAddress.zipCode.value,
				city: passengerAddress.city.value,
				state: passengerAddress.state
					? (searchOption(listOptions.states as SelectOptions[], passengerAddress.state.value) as SelectOptions)
					: undefined,
				checkAddressForAll: passengerAddress.checkAddressForAll ?? false
			};
			setValue(PassengerAddressFields.MODEL, updateData);
			if (updateData.state) setValue(PassengerAddressFields.STATE, updateData.state);
		}
	}, [passengerAddress]);

	return (
		<ErrorBoundaryProvider>
			<div className={styles.box_container}>
				{/* <h2 className={styles.box_title}>{t('TITLE_DESTINATION', { destination })}</h2> */}
				<h2 className={styles.box_title}>{t('TITLE_ADDRESS')}</h2>
				<div className={styles.box_content}>
					<div className={styles.box_input}>
						<InputTextCleaner
							{...register(PassengerAddressFields.ADDRESS, {
								required: t('ADDRESS_ERROR'),
								maxLength: 120
							})}
							name={PassengerAddressFields.ADDRESS}
							label={t('ADDRESS')}
							className={styles.box_input_text}
							labelStyles={styles.labelStyles}
							disabled={isFormDisabled}
							regexCleaner={REGEXP_CLEAN}
						/>
					</div>
					<div className={styles.box_input}>
						<InputTextCleaner
							{...register(PassengerAddressFields.ZIP_CODE, {
								required: t('POSTAL_CODE_ERROR')
							})}
							name={PassengerAddressFields.ZIP_CODE}
							label={t('POSTAL_CODE')}
							className={styles.box_input_text}
							labelStyles={styles.labelStyles}
							disabled={isFormDisabled}
							regexCleaner={REGEXP_CLEAN}
						/>
					</div>

					<div className={styles.box_input}>
						<InputTextCleaner
							{...register(PassengerAddressFields.CITY, {
								required: t('CITY_ERROR'),
								maxLength: 30
							})}
							name={PassengerAddressFields.CITY}
							regexCleaner={REGEXP_CITY}
							label={t('CITY')}
							className={styles.box_input_text}
							labelStyles={styles.labelStyles}
							disabled={isFormDisabled}
						/>
					</div>

					<div className={styles.box_input}>
						<ControllerInputSelect
							name={PassengerAddressFields.STATE}
							label={t('STATE')}
							options={listOptions.states as SelectOptions[]}
							rules={{ required: t('STATE_ERROR') }}
							disabled={isFormDisabled}
						/>
					</div>
				</div>
				{isMultiPassengers && (
					<InputCheckbox
						{...register(PassengerAddressFields.USE_ALL)}
						name={PassengerAddressFields.USE_ALL}
						label={t('USE_FOR_ALL')}
						className={styles.box_Checkbox}
						disabled={isFormDisabled}
					/>
				)}
			</div>
		</ErrorBoundaryProvider>
	);
};
PassengerAddress.displayName = 'PassengerAddress';
